 
namespace TabAurous.Sales {
    import fld = DeliveryChallanBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class DeliveryChallanBOMEditor extends _Ext.BOMGridEditor<DeliveryChallanBOMRow> { 
        protected getDialogType() { return DeliveryChallanBOMDialog; }
        protected getLocalTextPrefix() { return DeliveryChallanBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as DeliveryChallanItemsDialog).CalculateTotals();
                }
            });
        } 
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }  
    }
}